<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin: 0 0 0 20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/examinationQuestion'}">考试管理</el-breadcrumb-item>
                <el-breadcrumb-item>{{ word }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="content">
            <el-form :model="form" ref="form" :rules="rules" label-width="250px" class="demo-ruleForm"
                     style="width:80%;margin:0 auto">
                <el-form-item label="考试名称：" style="margin-bottom: 20px;" prop="name">
                    <el-input v-model="form.name" size="small" style="width: 400px;"></el-input>
                </el-form-item>
                <el-form-item label="试题类型：" prop="type">
                    <el-radio-group v-model="form.type" size="small">
                        <el-radio-button :label="0">考试模式</el-radio-button>
                        <el-radio-button :label="1">习题模式</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="考试时长：" style="margin-bottom: 20px;" prop="time">
                    <el-input placeholder="" v-model="form.time" size="small" style="width: 400px;">
                        <template slot="append">分钟</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="选择试题：" style="margin-bottom: 20px;" prop="subject">
                    <span>已选择 {{ multipleSelection.length }} 道题</span>
                    <el-link type="primary" :underline="false" style="margin-left: 30px" @click="showQuestions()">
                        选择试题
                    </el-link>
                    <el-link type="primary" :underline="false" style="margin-left: 20px"
                             @click="dialogVisibleView = true">预览试题
                    </el-link>
                </el-form-item>
                <el-form-item label="考试总分" prop="totalPoints">
                    <el-input v-model="form.totalPoints" style="width: 400px" type="number" size="small"/>
                </el-form-item>
                <el-form-item label="及格分数：" prop="passingScore">
                    <el-input v-model="form.passingScore" size="small" type="number" style="width: 400px;"></el-input>
                </el-form-item>
                <el-form-item label="制定部门" prop="createEmpDepId">
                    <el-select v-model="form.createEmpDepId" style="width: 400px" size="small" @change="depChange">
                        <el-option v-for="dep in depList" :key="dep.id" :value="dep.id" :label="dep.name"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="制定人" prop="createEmpId">
                    <el-select v-model="form.createEmpId" style="width: 400px" size="small" @change="userChange">
                        <el-option v-for="people in userList" :key="people.id" :value="people.id" :label="people.name"/>
                    </el-select>
                </el-form-item>
            </el-form>
            <div>
                <el-button type="primary" class="addBtn" size="small" @click="submitForm()">确定</el-button>
            </div>
        </div>


        <!-- 选题的弹窗 -->
        <el-dialog title="选题" :visible.sync="dialogVisible" width="80%" top="1vh" :show-close="false"
                   :close-on-click-modal="false" @close="closeDialog">
            <div style="display: flex;justify-content: space-between; margin-bottom: 15px">
                <div>
                    <el-button size="small" @click="resetSelect">清空</el-button>
                    <el-button type="primary" size="small" style="margin-left: 15px" @click="innerVisible = true">随机
                    </el-button>
                </div>
                <Input v-model="name" @on-search="searchInp" search enter-button placeholder="题目"
                       style="width: 300px"/>
            </div>
            <el-table :data="tableData" ref="multipleTable" @selection-change="handleSelectionChange"
                      :header-cell-style="{ fontWeight: 500, color: 'rgb(0,0,0,0.85)', background: '#fafafa' }"
                      :row-key="(row) => row.id" @row-click="handleClickTableRow" style="width: 100%" max-height="660">
                <el-table-column type="selection" width="55" :reserve-selection="true">
                </el-table-column>
                <el-table-column prop="queNo" label="编号" width="100"></el-table-column>
                <el-table-column prop="content" label="题目"></el-table-column>
                <el-table-column prop="score" label="分值" width="80"/>
                <el-table-column prop="options" label="选项">
                    <template slot-scope="scope">
                        <div v-if="scope.row.options">
							<span v-for="item in JSON.parse(scope.row.options)" :key="item.name">
								{{ item.name + '、' + item.value }}；
							</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="isMuchChoice" label="类别" width="100">
                    <template slot-scope="{ row }">
                        <span v-if="row.isMuchChoice === 1">单选</span>
                        <span v-else-if="row.isMuchChoice === 0 ">判断</span>
                        <span v-else>多选</span>
                    </template>
                </el-table-column>
                <el-table-column prop="correctAnswer" label="答案" width="100"></el-table-column>
            </el-table>
            <div style="text-align: right; margin-top: 10px">
                <Page :total="total" :page-size="pageSize" :current="currentPage" @on-change="curChange"/>
            </div>
            <!-- 内层的弹窗（随机抽题） -->
            <el-dialog width="50%" title="随机抽题" :visible.sync="innerVisible" append-to-body>
                <el-form :model="innerForm" ref="innerForm" label-width="80px" size="samll"
                         style="width: 85%;margin: auto">
                    <el-form-item label="单选题">
                        <div style="display: flex">
                            <el-input v-model="innerForm.singleChoiceNum" type="number" style="width: 80%"/>
                            <span style="margin-left: 10px">道题</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="多选题">
                        <div style="display: flex">
                            <el-input v-model="innerForm.multipleChoiceNum" type="number" style="width: 80%"/>
                            <span style="margin-left: 10px">道题</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="判断题">
                        <div style="display: flex">
                            <el-input v-model="innerForm.rightAndWrongNum" type="number" style="width: 80%"/>
                            <span style="margin-left: 10px">道题</span>
                        </div>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
					<el-button @click="innerVisible = false" size="small">取 消</el-button>
					<el-button type="primary" @click="innerSure" size="small">确 定</el-button>
				</span>
            </el-dialog>
            <span slot="footer" class="dialog-footer">
				<el-button @click="() => { dialogVisible = false; $refs.multipleTable.clearSelection()}" size="small">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false" size="small">确 定</el-button>
			</span>
        </el-dialog>

        <!-- 预览题的弹窗 -->
        <el-dialog title="已选择试题" :visible.sync="dialogVisibleView" width="80%" top="1vh">
            <el-table :data="multipleSelection" ref="multipleTable2"
                      :header-cell-style="{ fontWeight: 500, color: 'rgb(0,0,0,0.85)', background: '#fafafa' }"
                      :row-key="(row) => row.id" style="width: 100%" max-height="660">
                <el-table-column prop="queNo" label="编号" width="100"></el-table-column>
                <el-table-column prop="content" label="题目"></el-table-column>
                <el-table-column prop="options" label="选项">
                    <template slot-scope="scope">
                        <div v-if="scope.row.options">
							<span v-for="item in JSON.parse(scope.row.options)" :key="item.name">
								{{ item.name + '、' + item.value }}；
							</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="分值" width="80"/>
                <el-table-column prop="" label="操作" width="80">
                    <template slot-scope="{ row }">
                        <el-button type="text" style="color: #F56C6C" @click="deleteChoose(row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisibleView = false" size="small">取 消</el-button>
				<el-button type="primary" @click="dialogVisibleView = false" size="small">确 定</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import {randomExam, getAllDepartment, getDepartUser} from "@/api/processManager"

    export default {
        data() {
            var checkSubject = (rule, value, callback) => {
                if (this.multipleSelection === 0) {
                    callback(new Error('请选择考试题目'))
                } else {
                    callback()
                }
            }
            return {
                word: '', // 显示的字段是为添加还是编辑
                tableData: [],
                dialogVisible: false,
                dialogVisibleView: false, // 预览试题的弹窗
                rules: {
                    name: [{required: true, message: "请输入名称", trigger: "blur"}],
                    type: [{required: true, message: "请选择", trigger: "change"}],
                    time: [{required: true, message: "请输入考试时间", trigger: "blur"}],
                    subject: [{required: true, validator: checkSubject, trigger: "change"}],
                    totalPoints: [{required: true, message: "请输入考试总分", trigger: "blur"}],
                    passingScore: [{required: true, message: "请输入及格分数", trigger: "blur"}],
                    createEmpDepId: [{required: true, message: "请选择制定部门", trigger: "change"}],
                    createEmpId: [{required: true, message: "请选择制定人", trigger: "change"}],
                },
                options: [],
                getObj: {},
                isShowBtn: true,
                isShowBtn2: true,
                multipleSelection: [], // 已选择的题目的数组
                fileList: [],
                quesData: [],
                pageSize: 10,
                name: '',
                currentPage: 1,
                sfsdf: false,
                form: {},
                total: 0,
                pageTotal: 0,
                isAdd: true, //之前没有写这个变量
                innerForm: {
                    singleChoiceNum: 0,
                    multipleChoiceNum: 0,
                    rightAndWrongNum: 0
                },
                innerVisible: false,
                depList: [], // 部门的数组
                userList: [], // 某个部门下人员的数组
            };
        },
        async created() {
            await this.getAllDepart()
            let obj = this.$route.params.key;
            if (this.$route.params.key) {
                this.getUserList(obj.createEmpDepId)
                delete obj.questionIds
                delete obj.questionNum
                delete obj.gmtCreate
                this.isAdd = false;
                this.form = obj;
                // for (var i = 0; i < obj.questionIds.length; i++) {
                // 	var questionId = obj.questionIds[i];
                // 	this.multipleSelection.push(questionId);
                // }
                // console.log(this.multipleSelection)
                this.multipleSelection = obj.questionBankVos
                delete obj.questionBankVos
                this.word = "编辑"
            } else {
                this.form = {};
                this.word = "添加"
            }
        },
        methods: {
            // 获取所有部门
            async getAllDepart() {
                await getAllDepartment().then(res => {
                    this.depList = res.body.data
                })
            },
            // 部门改变
            depChange(id) {
                this.getUserList(id)
                this.$set(this.form, 'createEmpId', '')
                let obj = {}
                obj = this.depList.find((item) => {
                    return item.id === id
                })
                this.form.createEmpDepName = obj.name
            },
            // 获取某个部门下面的人员
            getUserList(id) {
                getDepartUser({demId: id}).then(res => {
                    this.userList = res.body.data
                })
            },
            // 人员改变
            userChange(id) {
                let obj = {}
                obj = this.userList.find((item) => {
                    return item.id === id
                })
                this.form.createEmpName = obj.name
            },
            submitForm() {
                let url = "";
                // console.log(this.form.totalPoints, this.form.passingScore)
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if (Number(this.form.totalPoints) < Number(this.form.passingScore)) {
                            this.$message.error('及格分数不能大于考试总分')
                            return
                        }
                        if (this.isAdd) {
                            url = this.componentsMoudel.getData("urls").saveQuestionnaire;
                        } else {
                            url = '/questionnaire/update';
                        }
                        let obj = {...this.form}
                        obj.selectQuestionBank = this.multipleSelection;
                        this.componentsMoudel.httpRequest
                            .getRequestHander(url)
                            .openLoad()
                            .startPost(obj)
                            .then((res) => {
                                this.$message({
                                    showClose: true,
                                    message: "保存成功",
                                    type: "success",
                                });
                                this.$router.push({
                                    path: "/processManager/examinationQuestion",
                                });
                            });
                    } else {
                        return false
                    }
                })
            },
            // 多选表格选中值改变的事件
            handleSelectionChange(rows) {
                this.multipleSelection = rows
                // console.log(rows)
            },
            // 点击行选中这一条信息（会触发上面handleSelectionChange这个事件）
            handleClickTableRow(row, column, event) {
                this.$refs.multipleTable.toggleRowSelection(row);
            },
            // 取消全部选中
            resetSelect() {
                this.$refs.multipleTable.clearSelection();
            },
            // 在预览框里面删除已选中的题目
            deleteChoose(id) {
                for (let i = 0; i < this.multipleSelection.length; i++) {
                    if (this.multipleSelection[i].id === id) {
                        this.multipleSelection.splice(i, 1)
                    }
                }
                let score = 0
                for (let i in this.multipleSelection) {
                    score += this.multipleSelection[i].score
                }
                this.$set(this.form, 'totalPoints', score)
            },
            // 打开选择试题的弹窗
            showQuestions() {
                this.dialogVisible = true;
                let oldArr = this.multipleSelection
                // await setTimeout(() => {
                // let arr1 = [] // 需要勾选的数组
                // // for(let i = 0; i < this.multipleSelection.length; i++) {
                // // 	for(let j = 0; j < this.tableData.length; j++) {
                // // 		if(this.multipleSelection[i].id === this.tableData[j].id) {
                // // 			arr1.push(this.tableData[j])
                // // 		}
                // // 	}
                // // }
                // 	this.resetSelect()
                // 	oldArr.forEach(row => {
                //     this.$refs.multipleTable.toggleRowSelection(row, true);
                // 	});
                // },0)
                this.$nextTick(() => {
                    this.resetSelect()
                    oldArr.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row, true);
                    });
                })
                this.multipleSelection = oldArr
                this.getData()
            },
            // 关闭选择试题的弹窗
            closeDialog() {
                this.dialogVisible = false
                let score = 0
                for (let i in this.multipleSelection) {
                    score += this.multipleSelection[i].score
                }
                this.$set(this.form, 'totalPoints', score)
            },

            async getData() {
                let param = {};
                param.limit = this.pageSize;
                param.curPage = this.currentPage;
                param.fileNameOrTag = this.fileNameOrTag;
                param.name = this.name
                await this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData("urls").getQuestion)
                    .openLoad()
                    .startPost(param)
                    .then((res) => {
                        this.tableData = res.body.data;
                        this.total = res.body.cum;
                        this.pageTotal = res.body.pageTotal;
                    });
            },
            // 搜索
            searchInp() {
                this.getData()
            },
            async curChange(val) {
                this.currentPage = val;
                let oldArr = this.multipleSelection
                // let arr1 = [] // 需要勾选的数组
                // for(let i = 0; i < this.multipleSelection.length; i++) {
                // 	for(let j = 0; j < this.tableData.length; j++) {
                // 		if(this.multipleSelection[i].id === this.tableData[j].id) {
                // 			arr1.push(this.tableData[j])
                // 		}
                // 	}
                // }
                // this.$refs.multipleTable.clearSelection();
                // setTimeout(() => {
                this.resetSelect()
                oldArr.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row, true);
                });
                this.multipleSelection = oldArr
                await this.getData()
                // },500)
            },

            // 内部弹窗的确定按钮
            innerSure() {
                randomExam(this.innerForm).then(res => {
                    let innerArr = res.body.data
                    this.resetSelect()
                    innerArr.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row, true);
                    })
                    this.multipleSelection = innerArr
                    this.getData()
                    this.innerVisible = false
                    this.innerForm = {
                        singleChoiceNum: 0,
                        multipleChoiceNum: 0,
                        rightAndWrongNum: 0
                    }
                })
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    };
</script>

<style scoped>
    .addBtn {
        display: block;
        width: 300px;
        margin: 0 auto;
    }
</style>
